import { Button, Container, Group, Text, Title } from '@mantine/core';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <Container>
      <Title order={1}>404 - Page Not Found</Title>
      <Text c="dimmed" size="lg" ta="center" mt="md">
        The page you are looking for does not exist.
      </Text>
      <Group justify="center" mt="xl">
        <Button component={Link} to="/" variant="subtle" size="md">
          Take me back to home page
        </Button>
      </Group>
    </Container>
  );
}
